$(function () {
    $(document).foundation();

    $('.mobile-menu-trigger').on('click', function () {
        $(this).toggleClass('spin');
        $('header.header .nav').addClass('mobile-mennu-fix').slideToggle(250);
    });
});

// Yoinked from https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
window.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('[role="tab"]');

    if (!tabs.length) {
        return;
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', changeTabs);
    });
});

function changeTabs(e) {
    const target = e.target;
    const parent = target.parentNode;
    const grandparent = parent.parentNode;

    parent
        .querySelectorAll('[aria-selected="true"]')
        .forEach(t => t.setAttribute('aria-selected', false));

    target.setAttribute('aria-selected', true);

    grandparent
        .querySelectorAll('[role="tabpanel"]')
        .forEach(div => div.setAttribute('hidden', true));

    grandparent.parentNode
        .querySelector(`#${target.getAttribute('aria-controls')}`)
        .removeAttribute('hidden');
}
